import {NoticeAPI} from '@/api'
import {login, requestEmail, SetHeader} from '@/api/access'
import store from '@/api/store'
import { HeaderWithoutMenu } from '../../mixins/header'
import ToggleBox from '../../mixins/togglebox'

const FB_FUNC = (m) => {
  // var params = m.split(':')
  // var id = params[0]
  // if (id === 'WEB_CHECK') {
  //     var status = params[1]
  //     var autologin = params[0]

  //     console.log(status, autologin)
  //     if(status === 'LOADED') {
  //         window.LMM_MOBILE_CHECK()
  //         setTimeout(function () {
  //             window.LMM_MOBILE_LOGIN('anysupport@koino.net', 'anysupport12')
  //         }, 100)
  //     }
  // }
  // else if (id === 'WEB_AUTH') {
  // }
  if (/^WEB_AUTH/.test(m)) m = 'WEB_AUTH'
}

export default {
  name: 'login-component',
  components: { HeaderWithoutMenu, ToggleBox },
  methods: {
    focusIn () {
      this.$refs.inpQrCode.focus()
    },
    checkValidQrCode (value, event) {
      let v = value.replace(/\D/g, '')
      this.optCode = v
    },
    noticePopupSkipChanged (value) {
      this.noticePopup.skip = value
    },
    noticePopupOpen (notice) {
      this.noticePopup.content = notice
      this.noticePopup.skipCheck = false
      this.noticePopup.show = true
    },
    noticePopupClose () {
      this.noticePopup.show = false
      if (this.noticePopup.skip) {
        store.set('notice_skip', this.noticePopup.content.pk)
      }
    },
    updatePopupSkipChanged (value) {
      this.updatePopup.skip = value
    },
    updatePopupClose () {
      this.updatePopup.show = false
      if (this.updatePopup.skip) {
        store.set('popup_skip', 'update')
      }
    },
    rememberChanged (value) {
      this.remember = value
      if (this.AppState.isApplication) {
        this.autoLoginStateHandler(value)
      }
    },
    changeMode(value) {
      this.rememberMode = value
    },
    autoLoginStateHandler (value) {
      this.autologinReadableValue = value ? 'YES' : 'NO'
      const today = new Date()
      const expire = new Date()
      expire.setDate(today.getDate() + 7)
      store.set('lmm_autologin', value, expire.getTime())
      if (window.LMM_MOBILE_SEND) {
        window.LMM_MOBILE_SEND('WEB_CHECK:CHANGED:' + this.autologinReadableValue)
      }
    },
    hideSendEmail () {
      this.showSendEmail = false
    },
    hideOTP () {
      this.showOTP = false
    },
    sendEmail () {
      let params = {
        email: this.verifyEmail,
        key: this.respData.mail
      }
      requestEmail(params)
        .then(resp => {
          if (/success/i.test(resp.result)) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'not_email_auth'}
            })
          } else {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'email_send_fail'}
            })
          }
        })
    },
    onSubmit (evt) {
      if (evt) evt.preventDefault()
      if (this.remember) store.set('remember', this.form.id)
      else store.remove('remember')

      if (this.rememberMode) store.set('rememberMode', this.modeSelected)
      else store.set('rememberMode', 'table')

      const authdata = {
        type: '1STEP',
        mail: this.form.id,
        pw: this.form.passwd
      }
      
      login(authdata, (err, resp) => {
        if (err) {
          this.respData = err.objects
          const res = this.respData
          if (/fail/i.test(res.step1)) {
            let messageKey = ''
            if (res.cause) {
              for (let key in res.cause) {
                let limit = res.failure_limit
                let current = res.current_failure
                if (limit != 0 && limit == current) {
                  messageKey = 'login_failure_limit'
                } else if (key === 'pw_reject') {
                  this.$router.push({name: 'access-retypepassword', params: {userid: authdata.mail}})
                  messageKey = 'password_change_limit'
                } else{
                  messageKey = 'login_failed_cause_' + key
                }
              }
            } else {
              messageKey = 'invalid_id_and_pw'
            }
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: messageKey},
              userId: this.form.id,
              selfUnlock: res.self_unlock
            })
          } else if (/fail/i.test(res.step2)) {
            this.verifyEmail = res.email
            this.showSendEmail = true
          } else if (/fail/i.test(res.step3)) {
            this.respData.profile = this.respData.mail.replace(/[@.]/g, '_')
            this.showOTP = true
          }
          return
        }
        if (this.AppState.isApplication) {
          window.LMM_MOBILE_SEND('WEB_AUTH:' + btoa(JSON.stringify({userid: authdata.mail, userpw: authdata.pw})))
          window.LMM_MOBILE_EXIST_AUTH = true
        }
        this.AppState.Info.dateFmt = resp.dateFmt
        this.$router.push({name: 'deviceAll', params: {groupPk: 'all'}})

        if (this.modeSelected === 'card') {
          this.AppState.isIconView = true
          store.set('icon_view', true)
        } else {
          this.AppState.isIconView = false
          store.set('icon_view', false)
        }
  
      })
    },
    otpLogin () {
      if (!this.respData.token) return
      SetHeader('token', this.respData.token)
      let authdata = {
        type: '3STEP',
        code: this.optCode
      }
      login(authdata, (err, resp) => {
        if (err) {
          let res = err.objects
          if (/fail/i.test(res.step3)) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'invalid_otp'}
            })
          } else {
            this.$log.error(res)
          }
          return
        }

        this.AppState.Info.dateFmt = resp.dateFmt
        this.$router.push({name: 'deviceAll', params: {groupPk: 'all'}})
      })
    }
  },
  created () {
    let params = {
      by: 'notice_date',
      limit: 3,
      offset: 0,
      order: 'desc',
      search_mode: 'pagination',
      type: 'ko'
    }
    NoticeAPI.get('', {params})
      .then(resp => {
        const today = new Date().getTime()
        const notices = resp.data.objects
        this.notice = notices
        if (notices.length) {
          let stored = store.get('notice_skip')
          if (stored === notices[0].pk) return
          const noticeDate = new Date(notices[0].notice_date).getTime()
          if (noticeDate > today) {
            this.noticePopup.content = notices[0]
            if (!process.env.VUE_APP_STATIC_NOTICE) {
              this.noticePopup.skipCheck = true
            }
            this.noticePopup.show = true
          }
        }
      })

    //updatePopup
    let updatePopupStored = store.get('popup_skip')
    if (updatePopupStored !== 'update') {
      this.updatePopup.show = true
    }

    const rememberID = store.get('remember')
    if (rememberID) {
      this.remember = true
      this.form.id = rememberID
    } else this.remember = false

    const rememberMode = store.get('rememberMode')
    if (rememberMode) {
      this.rememberMode = true
      this.modeSelected = rememberMode
    } else this.rememberMode = false

    if (this.AppState.isMobile) {
      this.autoLoginStateHandler(this.remember)
      window.LMM_MOBILE_SEND = (function () {
        if (/android/i.test(this.AppState.os)) {
          return function (m) {
            try {
              window.AndroidViewerApp.setMessage(m)
            } catch (e) {  
              FB_FUNC(m)
            }
          }
        } else if (/ios/i.test(this.AppState.os)) {
          return function (m) {
            try {
              window.webkit.messageHandlers.observe.postMessage(m)
            } catch (e) {
              FB_FUNC(m)
            }
          }
        } else return function (m) { FB_FUNC(m) }
      }.call(this))

      window.LMM_MOBILE_CHECK = () => {
        this.AppState.isApplication = true
        store.set('LMM_MOBILE_APPLICATION', true)

        window.LMM_MOBILE_LOGIN = () => {
          this.$log.info('EXIST LOGGED IN')
          window.LMM_MOBILE_EXIST_AUTH = false
        }

        if (!window.LMM_MOBILE_EXIST_AUTH) {
          window.LMM_MOBILE_LOGIN = (id, pw) => {
            window.LMM_MOBILE_EXIST_AUTH = true
            // TRY LOGIN
            this.form.email = id
            this.form.passwd = pw
            // this.form.mode = mode
            this.$nextTick(() => {
              this.onSubmit()
            })
          }
        }
      }

      window.LMM_MOBILE_SEND('WEB_CHECK:LOADED:' + this.autologinReadableValue)
    }
  },
  data () {
    return {
      form: {
        email: '',
        passwd: ''
      },
      remember: null,
      rememberMode: null,
      showSendEmail: false,
      verifyEmail: null,
      respData: {},
      showOTP: false,
      optCode: null,
      noticePopup: {
        show: false,
        content: null,
        skip: false,
        skipCheck: false
      },
      updatePopup: {
        show: false,
        content: null,
        skip: false,
        skipCheck: false
      },
      modeSelected: 'table',
      notice: [],
      autologinReadableValue: 'NO'
    }
  }
}